var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.isAuthenticated && _vm.userRole === 1 && !_vm.isOrderRoute)?_c('sidebar'):_vm._e(),(_vm.isAuthenticated && _vm.userRole === 2)?_c('writerNavDraw'):_vm._e(),_c('v-main',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }